export default function Maps_Types() {
  return (
    <div>
      <h1>Maps_Types Component</h1>
    </div>
  );
}
